export default {
  tab: {
    allExchanges: 'All Exchanges',
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
  typeTab: {
    bulVal: 'FR.BUY VAL.',
    sellVal: 'FR.SELL VAL.',
    buyVol: 'FR. BUY VOL.',
    sellVol: 'FR. SELL VOL.',
    volume: 'VOLUME',
    value: 'VALUE',
    marketCap: 'MARKET CAP',
  },
  noData: 'No data available.',
  ticker: 'TICKER',
  price: 'PRICE',
  percentChange: '% CHANGE',
  marketCap: 'MARKET CAP (BN.)',
  volume: 'VOLUME',
  value: 'VALUE',
  frBuyVol: 'FR.BUY VOL.',
  frSellVol: 'FR.SELL VOL.',
  frBuyVal: 'FR.BUY VAL.',
  frSellVal: 'FR.SELL VAL.',
};
